import {required} from "vuelidate/lib/validators";  
const satdosyafatura  = {
    data() { 
      return {   
        satdosyafaturaData: { 
          Dosyaid: "",
          Dosyafirmaid: "",
          Faturatarihi: "",
          Birimid: null,
          Faturanumarasi: "", 
          Faturatutari:"",
          Kdvlifaturatutari: null,
          Onaytarihvenumarasi: "",
          }, 
          FormDataType:{
            Faturatarihi:{FieldName:"Faturatarihi",Field:"fate",FieldTitle:this.$t('satdosyafatura.AddEdit.Faturatarihi')},
            Birimid:{FieldName:"Birimid",Field:"combobox",FieldTitle:this.$t('satdosyafatura.AddEdit.Birimid'),ComboDataArray:[]},
            Faturanumarasi:{FieldName:"Faturanumarasi",Field:"input",FieldTitle:this.$t('satdosyafatura.AddEdit.Faturanumarasi')},
            Faturatutari:{FieldName:"Faturatutari",Field:"input",FieldTitle:this.$t('satdosyafatura.AddEdit.Faturatutari'),FieldType: "number"},
            Kdvlifaturatutari:{FieldName:"Kdvlifaturatutari",Field:"input",FieldTitle:this.$t('satdosyafatura.AddEdit.Kdvlifaturatutari'),FieldType: "number"},
            Onaytarihvenumarasi:{FieldName:"Onaytarihvenumarasi",Field:"input",FieldTitle:this.$t('satdosyafatura.AddEdit.Onaytarihvenumarasi')}
          } 
      }
    }, 
    validations:{ 
      FormData: {  
        Faturatarihi: {required },  
        Birimid: { required }, 
        Faturanumarasi: { required },  
        Faturatutari: { required },
        Kdvlifaturatutari: { required },
        Onaytarihvenumarasi: { required }
      }
 
  },
  created(){
    let Page= {
      PageNumber: "1",
      PageSize: "9999"
    }

      this.ActionsGet({"Service":"obirim", "Page":Page}).then((res) => {
          for(var i=0; i<res.Data.length; i++)
          {
            this.FormDataType.Birimid.ComboDataArray.push ({id:res.Data[i].Id,label:res.Data[i].BirimAdi})
          } 

      });
  }
}
export default satdosyafatura 